<template>
  <div>
    <search-agent-esim @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showRegisterEimModal"
          v-if="isShowMenu('agent_esims/register_eim')"
        >注册eIM</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="eid" slot-scope="text, record">
        <a @click="showDetail(record)">{{ text }}</a>
      </span>
      <span slot="actions" slot-scope="text, record">
        <a
          v-if="isShowMenu('agent_esims/download_profile')"
          @click="showDownloadModal(record)"
        >下载 Profile</a>
        <span v-else>-</span>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <register-esim-to-eim
      v-if="isShowRegisterEimModal"
      :visible.sync="isShowRegisterEimModal"
      :agent-id="agentId"
      :eids="selectedEids"
      @completed="fetchData"
    />

    <download-profile
      v-if="isShowDownloadModal"
      :visible.sync="isShowDownloadModal"
      :esim-id="currentEsimId"
      :eid="currentEid"
      :agent-id="agentId"
      @completed="fetchData"
    />

    <show-esim
      v-if="isShowDetailModal"
      :visible.sync="isShowDetailModal"
      :id="currentEsimId"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findAgentEsims } from '@/api/agent'
import Pagination from '@/components/Pagination'
import SearchAgentEsim from '@/views/esims/agent/Search'

export default {
  name: 'AgentEsimList',
  components: {
    Pagination,
    SearchAgentEsim,
    RegisterEsimToEim: () => import('@/views/batch_operations/RegisterEsimToEim'),
    DownloadProfile: () => import('@/views/esims/DownloadProfile'),
    ShowEsim: () => import('@/views/esims/Show')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowRegisterEimModal: false,
      isShowDownloadModal: false,
      isShowDetailModal: false,
      currentEsimId: 0,
      currentEid: '',
      selectedRowKeys: [],
      pagination: { total_count: 0 },
      query: { per_page: 10 },
      columns: [
        {
          title: 'EID',
          dataIndex: 'eid',
          width: 320,
          fixed: 'left',
          scopedSlots: { customRender: 'eid' }
        },
        { title: '产品名称', dataIndex: 'product_name', width: 160 },
        { title: 'SGP规范', dataIndex: 'sgp_spec_names', width: 140 },
        { title: 'eIM平台', dataIndex: 'eim_platform_name', width: 120 },
        { title: 'eIM注册状态', dataIndex: 'eim_register_status_name', width: 120 },
        { title: '在线状态', dataIndex: 'eim_online_status_name', width: 100 },
        { title: '支持协议', dataIndex: 'eim_support_protocol_name', width: 100 },
        { title: '请求间隔(秒)', dataIndex: 'eim_request_interval', width: 120 },
        { title: '关联 Profile 数量', dataIndex: 'linked_profile_count', width: 140 },
        { title: '更新时间', dataIndex: 'eim_data_updated_at', width: 170 },
        { title: '卡片材质', dataIndex: 'card_type_name', width: 120 },
        { title: '卡片尺寸', dataIndex: 'card_shape_name', width: 120 },
        { title: '订单编号', dataIndex: 'order_no', width: 180, ellipsis: true },
        { title: '划拨时间', dataIndex: 'allocated_at', width: 170 },
        {
          title: '操作',
          dataIndex: 'actions',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },
    selectedEids() {
      const idSet = new Set(this.selectedRowKeys)
      return this.data
        .filter((row) => idSet.has(row.id))
        .map((row) => row.eid)
        .filter((eid) => eid)
    }
  },
  watch: {
    agentId() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showRegisterEimModal() {
      this.isShowRegisterEimModal = true
    },
    showDownloadModal(record) {
      this.currentEsimId = record.id
      this.currentEid = record.eid
      this.isShowDownloadModal = true
    },
    showDetail(record) {
      this.currentEsimId = record.id
      this.currentEid = record.eid
      this.isShowDetailModal = true
    },
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findAgentEsims(this.agentId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    }
  }
}
</script>
